export default "__VITE_ASSET__DYGzqnZv__"